import React from 'react'

const LinkIcon = () => {
	return (
		<svg width={41} height={24} viewBox='0 0 41 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M40.244 15.246c-.113-4.446-3.822-8.027-8.268-7.984l-1.961.02.07 2.773 1.96-.02a5.338 5.338 0 013.78 1.513 5.339 5.339 0 011.644 3.724 5.199 5.199 0 01-5.156 5.34l-12.135.12c-2.918.028-5.351-2.321-5.425-5.237a5.199 5.199 0 015.157-5.34l4.515-.044-.07-2.774-4.516.045a7.925 7.925 0 00-7.861 8.14 8.166 8.166 0 002.508 5.674 8.17 8.17 0 005.761 2.309l12.137-.118a7.925 7.925 0 007.86-8.141zM28.6 8.814a8.137 8.137 0 00-2.505-5.678A8.14 8.14 0 0020.33.831L8.195.95a7.925 7.925 0 00-7.86 8.14 8.168 8.168 0 002.508 5.674 8.168 8.168 0 005.76 2.309l1.951-.02-.07-2.773-1.95.019c-2.918.029-5.351-2.32-5.426-5.236a5.198 5.198 0 015.157-5.34l12.136-.12a5.338 5.338 0 013.78 1.513 5.338 5.338 0 011.643 3.725 5.198 5.198 0 01-5.155 5.34l-4.418.043.07 2.774 4.418-.044a7.925 7.925 0 007.86-8.141z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default LinkIcon
